import { render, staticRenderFns } from "./PurchasePlanList.vue?vue&type=template&id=e794c918&scoped=true&"
import script from "./PurchasePlanList.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e794c918",
  null
  
)

export default component.exports